import { classes } from "./react"

type DialogBodyIntroProps = {
    className?: string
}

export const DialogBodyIntro: React.FunctionComponent<React.PropsWithChildren<DialogBodyIntroProps>> = ({
    children,
    className,
}) => <div className={classes("modal-body-intro", className)}>{children}</div>
